import * as url from "../../helpers/url_helper";
import { apiCall } from "./apiService";

/**
 * Updates discount type and max discount for a store
 * @param {string} storeDomain - Store domain
 * @param {string} discountType - Discount type ('Automatic', 'Manual', 'Paused')
 * @param {number} maxDiscount - Max discount percentage (required for Manual type)
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const updateDiscountType = async (storeDomain, discountType, maxDiscount, notifyError) => {
    const body = {
        store_domain: storeDomain,
        discount_type: discountType,
        max_discount: discountType === 'Manual' ? Number(maxDiscount) : 0,
    };

    return await apiCall(
        url.PUT_UPDATE_MERCHANTS,
        'PUT',
        body,
        notifyError,
        "Failed to update discount type"
    );
};

